import { _isEmptyString } from '@/littledash';

import { MAX_CAGE_POPULATION } from '@/constants/cage';
import type { SpreadsheetSettings } from '@/components/UI/SpreadSheet/SpreadSheet.model';

/**
 * Cage name validator for Handsontable.
 * Validates that the name is non-empty and at most 50 characters.
 */
export const cageNameValidator = (value: unknown, callback: (valid: boolean) => void): void => {
  const strValue = typeof value === 'string' ? value : '';
  callback(!_isEmptyString(strValue) && strValue.length <= 50);
};

/**
 * Population validator for Handsontable.
 * Validates that the value is a valid number between 0 and MAX_CAGE_POPULATION.
 */
export const populationValidator = (value: unknown, callback: (valid: boolean) => void): void => {
  const num = Number(value);
  callback(
    !isNaN(num) && value !== null && value !== undefined && value !== '' && num >= 0 && num <= MAX_CAGE_POPULATION
  );
};

/**
 * Returns the initial Handsontable settings for cage creation.
 * Columns: catalog (hidden, readonly), Cage Name (text), Population (numeric).
 */
export const initCageSettings = (): SpreadsheetSettings => ({
  columns: [
    {
      data: 'catalog',
      value: 'No',
      width: 150,
      readOnly: true,
    },
    {
      data: 'name',
      value: 'Name',
      type: 'text',
      width: 150,
      validator: cageNameValidator,
      validationErrorMessage: (value: unknown) => `${value ?? 'Value'} name must have a maximum of 50 characters`,
      linkedValidationColumns: ['population'],
    },
    {
      data: 'population',
      value: 'Population',
      type: 'numeric',
      width: 150,
      validator: populationValidator,
      validationErrorMessage: (value: unknown) =>
        `${value ?? 'Value'} must be a number with a maximum of ${MAX_CAGE_POPULATION}`,
      linkedValidationColumns: ['name'],
    },
  ],
  hiddenColumns: {
    columns: [0],
  },
  colHeaders: ['No', 'Cage Name', 'Population'],
  columnSorting: false,
  contextMenu: {
    items: {
      remove_row: {},
    },
  },
  className: 'htMiddle',
  manualColumnResize: true,
  rowHeights: 50,
  height: 500,
  rowHeaders: true,
});
